module.exports = __webpack_public_path__ + "img/search_lists.69a1c70b.svg";